/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-07-01 14:56:56
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-02 20:44:11
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Currency/constant.ts
 */
export const INITIAL_STATE: Currency = {
  fixedRate: true,
  currencyCode: undefined,
  currencyName: undefined,
  rate: 0,
  maxRate: null,
  minRate: 0,
  realTimeRate: 0,
};

export type Currency = {
  currencyCode: string;
  currencyName: string;
  fixedRate: boolean;
  rate: number;
  maxRate: number;
  minRate: number;
  salesChannels?: any;
  realTimeRate: number;
  maxRateChecked?: boolean;
  minRateChecked?: boolean;
};
export const conversionOptions = ({ getI18n }) => [
  {
    label: getI18n('storeCurrency.index.wHOLE_NUMBERS'),
    value: 'WHOLE_NUMBERS',
    index: 1,
  },
  {
    label: getI18n('storeCurrency.index.tENTHS'),
    value: 'TENTHS',
    index: 2,
  },
  {
    label: getI18n('storeCurrency.index.hUNDREDTHS'),
    value: 'HUNDREDTHS',
    index: 3,
  },
  {
    label: getI18n('storeCurrency.index.tHOUSANDTHS'),
    value: 'THOUSANDTHS',
    index: 4,
  },
  {
    label: getI18n('storeCurrency.index.tEN_THOUSANDTHS'),
    value: 'TEN_THOUSANDTHS',
    index: 5,
  },
  {
    label: getI18n('storeCurrency.index.hUNDRED_THOUSANDTHS'),
    value: 'HUNDRED_THOUSANDTHS',
    index: 6,
  },
  {
    label: getI18n('storeCurrency.index.mILLIONTHS'),
    value: 'MILLIONTHS',
    index: 7,
  },
  {
    label: getI18n('storeCurrency.index.tEN_MILLIONTHS'),
    value: 'TEN_MILLIONTHS',
    index: 8,
  },
  {
    label: getI18n('storeCurrency.index.hUNDRED_MILLIONTHS'),
    value: 'HUNDRED_MILLIONTHS',
    index: 9,
  },
  {
    label: getI18n('storeCurrency.index.bILLIONS'),
    value: 'BILLIONS',
    index: 10,
  },
];
